export const deepEquals = (a: any, b: any) => {
    if ((a instanceof Object) && (b instanceof Object)) {
        if (a.constructor !== b.constructor) {
            return false;
        }

        if ( Array.isArray(a) && Array.isArray(b) && a.length !== b.length) {
            return false;
        }

        for (const key in a) {
            if (!!a[key] && a.hasOwnProperty(key)) {
                if (!b.hasOwnProperty(key) || !deepEquals(a[key], b[key])) {
                    return false;
                }
            } else {
                if (typeof a[key] !== typeof b[key]) {
                    return false;
                }
            }
        }

        for (const key in b) {
            if(!!b[key] && b.hasOwnProperty(key)) {
                if (!a.hasOwnProperty(key) || !deepEquals(b[key], a[key])) {
                    return false;
                }
            } else {
                if (typeof a[key] !== typeof b[key]) {
                    return false;
                }
            }
        }

        return true;
    }

    return a === b;
}
